import { Heading, ButtonRow, Button, Treegrid, FormTextInput } from "cai-fusion"
import { useNavigate, useParams } from "react-router-dom";

import { ReactComponent as RippleLoading } from "../../../../images/ripple-loading.svg"

import GIFAnimationLoading from "../../../../images/icon-loading-spinner.gif"
import { useState, useEffect } from "react";
import { useSiftV2 } from "../../contexts/siftV2Context";
import { processFiles } from "../../../fusion/FileUpload/helpers";
import DnDFileUpload from "../../../fusion/FileUpload/DragAndDrop";
import { debugLog } from "../../../../configs/loggingConfig";

const OppUploadFileItem = ({fileName, onDelete, isUploading = false}) => {
    return (
        <tr className="o-treegrid__row o-treegrid__row--shown">
            <td className="o-treegrid__cell">
                <span className="a-subtle-text"><strong>{fileName}</strong></span>
            </td>
            <td className="o-treegrid__cell">
                { !isUploading && <Button outline fullWidth size="small" children="Remove" onClick={onDelete} /> }
                { isUploading && <div className="m-loader m-loader--inline">
                    <RippleLoading className="m-loader__img" />
                    <p className="m-loader__label">Uploading</p>    
                </div>}
            </td>
        </tr>
    )
}

const SiftCreateOpportunity = () => {

    const navigate = useNavigate();
    const params = useParams();

    const { currOppType, currTypeId, setCurrTypeId, startProcess } = useSiftV2();

    const [files, setFiles] = useState([]);
    const [title, setTitle] = useState("");

    useEffect(() => {
        if (currTypeId != params.OppTypeId) {
            setCurrTypeId(params.OppTypeId);
            document.title = "Sift V2 - New Opportunity"
        }
    }, [])

    const deleteFiles = (fileInd) => {
        let filesCopy = [...files];
        filesCopy = [...filesCopy.slice(0, fileInd), ...filesCopy.slice(fileInd + 1)]
        setFiles([...filesCopy]);
    }
    
    const handleFileUpload = async (newFiles) => {
        const processedFiles = await processFiles(newFiles);
        setFiles([...files, ...processedFiles]);
        debugLog.log("[FILEHANDLER] Added files. New file list:", ([...files], [...processedFiles]));
    }

    return (
        <div className="o-page-section o-page-section l-pt-none">
            <div className="o-page-section__content-container o-page-section__content-container--extra-narrow l-pt-none l-mt-neg-sm">
                <div className="l-row l-pt-sm">
                    <div className="col-md-12">
                        <Heading size={1}>{`New ${currOppType.name ?? "Opportunity"}`}</Heading>
                        <p className="a-muted-text">To get started, drag the files associated with the new opportunity into the box below, or click the box to browse for the files on your computer.</p>
                        <div className="row">
                            <div className="col-12">
                                <FormTextInput
                                    displayName="Opportunity Title"
                                    formValue={title}
                                    onInputChange={(fieldId, newValue) => {
                                        setTitle(newValue)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="o-block o-block--body">
                                    {/* File Uploader */}
                                    <DnDFileUpload 
                                        onFileUpload={handleFileUpload}
                                        // onRejectedFiles={(files) => {
                                        //     rejectToast(files, createToast);
                                        // }}
                                    />
                                    {/* File List */}
                                    { files.length === 0 
                                    ?   <div className="text-center" aria-colspan={4}>
                                            <p className="a-muted-text l-mt-xs">You currently have no files selected.</p>
                                        </div>
                                    :   <Treegrid isCompact columnSizes={["medium", "48"]} className="l-mt-sm">
                                            {files.map((file, index) => (
                                                <OppUploadFileItem 
                                                    key={file.resourceName}
                                                    fileName={file.resourceName}
                                                    onDelete={() => deleteFiles(index)}
                                                />
                                            ))}
                                        </Treegrid>
                                    }
                                </div>
                            </div>
                        </div>
                        {/* ButtonRow */}
                        <ButtonRow className="l-mt-sm">
                            <Button outline children="Cancel"/>
                            <Button 
                                //disabled={files.length === 0 || !currOppType?.title}
                                onClick={() => {
                                    startProcess(title, files);
                                    navigate(`/${process.env.REACT_APP_BRANDING_SIFT_PATH ?? "sift"}/processing`);
                                    }
                                }
                                children="Create"
                            />
                        </ButtonRow>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SiftCreateOpportunity;



// A possible block for when the current opportunity type isn't loaded in yet.
// Might be something to add if end-users complain about a lack of responsiveness when accessing this page from URL as opposed to the prior page.
{/* <div className="o-block">
    <div className="row">
        <div className="col-2">
            <img src={GIFAnimationLoading} className="a-responsive-image" style={{width: "64px"}}/>
        </div>
        <div className="col-10">
            <Heading size={3}>Loading your opportunity type...</Heading>
            <p>We're loading your opportunity type! Please be patient.</p>
        </div>
    </div>
</div> */}